import React, { FunctionComponent } from 'react';
import { ThemeProvider as Provider } from 'styled-components';
import { ThemeConfiguration, TonalRange } from '../../compat/colors';
import { useTheme } from '../../compat/core';

import { SplashThemeProps } from './types';

export const SplashTheme: FunctionComponent<SplashThemeProps> = (props) => {
  const { color, tone, accent } = useTheme();
  const mappedTone: TonalRange = tone === 'very-dark-gray' ? tone : 'bright';
  const dialogTheme: ThemeConfiguration = {
    color,
    tone: mappedTone,
    accent,
  };

  return <Provider {...props} theme={dialogTheme} />;
};
